"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const normal_attack_1 = tslib_1.__importDefault(require("../common/normal-attack"));
const group_attack_1 = tslib_1.__importDefault(require("../common/group-attack"));
exports.karakasakozou_skill1 = (new normal_attack_1.default('我顶！'));
exports.karakasakozou_skill2 = (new group_attack_1.default(2, '天旋地转', 1.29, 2, 2));
